import { useMemo } from 'react';

import { dealItemsLoadingState } from '@/states/products.state';
import { useAtomValue } from 'jotai';

import { useGetAllCountryLabels } from './useGetAllCountryLabels';

export function useTableDataReady(_dealId: string) {
  const { initialLoading: productsLoading, error: productsError } =
    useAtomValue(dealItemsLoadingState);
  const {
    loading: countriesLoading,
    error: countriesError,
    countryLabels,
  } = useGetAllCountryLabels();

  const isReady = useMemo(() => {
    return !productsLoading && !countriesLoading && countryLabels.length > 0;
  }, [productsLoading, countriesLoading, countryLabels.length]);

  const isLoading = useMemo(() => {
    return productsLoading || countriesLoading;
  }, [productsLoading, countriesLoading]);

  const hasError = useMemo(() => {
    return !!productsError || !!countriesError;
  }, [productsError, countriesError]);

  return {
    isReady,
    isLoading,
    hasError,
    productsError,
    countriesError,
  };
}
